import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(() => ({
  container: { marginInline: 'auto', maxWidth: 1180 },
}));
